var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThumbsdownactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "17px",
    viewBox: "0 0 19 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "27785653-72A2-47F2-BD0E-470A3947F4F3@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.27007431e-16,6.4 L3.2,6.4 L3.2,16 L6.27007431e-16,16 L6.27007431e-16,6.4 Z M6.4,16 L13.6,16 C14.264,16 14.832,15.6 15.072,15.024 L17.488,9.38399996 C17.56,9.2 17.6,9.008 17.6,8.8 L17.6,7.2 C17.6,6.32 16.88,5.6 16,5.6 L10.952,5.6 L11.712,1.944 L11.736,1.688 C11.736,1.36 11.6,1.056 11.384,0.84 L10.536,-1.7914498e-16 L5.264,5.272 C4.976,5.56 4.8,5.96 4.8,6.4 L4.8,14.4 C4.8,15.28 5.52,16 6.4,16 Z M6.4,6.4 L9.872,2.928 L8.8,7.2 L16,7.2 L16,8.8 L13.6,14.4 L6.4,14.4 L6.4,6.4 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27007431e-16,6.4 L3.2,6.4 L3.2,16 L6.27007431e-16,16 L6.27007431e-16,6.4 Z M6.4,16 L13.6,16 C14.264,16 14.832,15.6 15.072,15.024 L17.488,9.38399996 C17.56,9.2 17.6,9.008 17.6,8.8 L17.6,7.2 C17.6,6.32 16.88,5.6 16,5.6 L10.952,5.6 L11.712,1.944 L11.736,1.688 C11.736,1.36 11.6,1.056 11.384,0.84 L10.536,-1.7914498e-16 L5.264,5.272 C4.976,5.56 4.8,5.96 4.8,6.4 L4.8,14.4 C4.8,15.28 5.52,16 6.4,16 Z M6.4,6.4 L9.872,2.928 L8.8,7.2 L16,7.2 L16,8.8 L13.6,14.4 L6.4,14.4 L6.4,6.4 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GTM_Topic-Collection_Feedback_V3",
    transform: "translate(-1241.000000, -733.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(1250.252275, 741.241222) rotate(180.000000) translate(-1250.252275, -741.241222) translate(1241.452275, 733.241222)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-Selected-/-On-Surface-/-Inactive-Copy-Clipped",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Icons-/-Selected-/-On-Surface-/-Inactive-Copy",
    mask: "url(#mask-4)",
    fill: "#5D289B"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.800000, -1.600000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 19.392,
    height: 19.392
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsdownactive);
export default __webpack_public_path__ + "static/media/thumbsdownactive.6fc3afc4275f6d82f8d921319e6db08e.svg";
export { ForwardRef as ReactComponent };